<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import { applyTheme, watchSystemTheme } from '@/utils/theme';

@Component
export default class App extends Vue {
  checkConnection() {
    if (navigator.onLine) {
      this.$store.dispatch('internet', false, { root: true });
    } else {
      this.$store.dispatch('internet', true, { root: true });
    }
  }

  created() {
    applyTheme(this.$vuetify);
    watchSystemTheme(this.$vuetify);
    if (process.env.NODE_ENV === 'production') {
      // TODO: have to make request whenever the page detects internet and reloads the page
      setInterval(() => {
        this.checkConnection();
      }, 4000);
    }
  }
}
</script>
<style></style>
